import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import auth from '../../services/auth';
import { lerSenhaSalva, salvarSenha, esquecerSenha, validarSenha } from '../../services/senhaSalva';
import GridContainer from "../Grid/GridContainer.js";
import GridItem from "../Grid/GridItem.js";
import Card from "../Card/Card.js";
import CardHeader from "../Card/CardHeader.js";
import CardIcon from "../Card/CardIcon.js";
import CardBody from "../Card/CardBody.js";
import CardFooter from "../Card/CardFooter.js";
import Icon from "@material-ui/core/Icon";
import PasswordModal from "../PasswordModal/PasswordModal.js";
import {
    contagemPorNome, montarPorHora, ritmoDoDia, montarFila, montarMaisDemorados, tempoMedioFinalizados, montarAtendentes,
    montarTipos, montarClientes, montarDuracao, montarAlertas, situacaoIdade, formatarMinutos,
    formatarPercentual, num,
} from './indicadores';
import './compdashboard.css';

const RECARGA_MS = 60000;
const LOGIN_LUK = 'LUK';
const ESPERA_RECONEXAO_MS = 30000;

// Cores dos gráficos no fundo claro.
const COR = {
    serie: '#2a78d6',
    serieOntem: 'rgba(42, 120, 214, 0.30)',
    media: '#52514e',
    grade: '#e1e0d9',
    eixo: '#898781',
};

const NIVEL_ROTULO = {
    critico: 'Crítico',
    serio: 'Atenção',
    atencao: 'Observar',
    info: 'Informação',
    bom: 'Tudo certo',
};

const SITUACAO_ROTULO = { critico: 'atrasado', serio: 'demorando', normal: '' };

function horaMinuto(data) {
    return data ? data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '--:--';
}

class CompDashBoard extends Component {

    state = {
        showPasswordModal: !lerSenhaSalva(),
        passwordValidated: false,
        carregado: false,
        semConexao: false,
        falhas: 0,
        atualizadoEm: null,
        resumo: {},
        noticias: [],
        porHora: null,
        emAberto: null,
        finalizadosGraf: null,
        tipos: [],
        duracao: null,
        clientes: [],
        chamadosDia: [],
        atendentesON: [],
    }

    // Função para verificar a senha digitada
    checkPassword = async (senha) => {
        const valida = await validarSenha(senha);
        if (valida) {
            return true;
        }
        if (valida === null) {
            // Servidor fora ou lotado: não dá para saber se a senha está certa
            alert("Não foi possível falar com o servidor agora. Tente de novo em alguns instantes.");
            this.setState({ showPasswordModal: true });
            return false;
        }
        alert("Senha incorreta. Você será redirecionado.");
        window.location.href = "https://www.lukos.com.br"; // Redireciona para outra página
        return false;
    };

    componentDidMount() {
        this.tentarSenhaSalva();
    }

    // Com senha lembrada, entra direto; se ela não vale mais (ex.: mudou), esquece e pede de novo.
    // Sem conexão, mantém a senha e tenta de novo sozinho (a TV fica sem ninguém para clicar).
    tentarSenhaSalva = async () => {
        const senhaSalva = lerSenhaSalva();
        if (!senhaSalva) {
            return;
        }
        const valida = await validarSenha(senhaSalva);
        if (valida) {
            this.setState({ semConexao: false });
            this.liberarPainel();
        } else if (valida === false) {
            esquecerSenha();
            this.setState({ semConexao: false, showPasswordModal: true });
        } else {
            this.setState({ semConexao: true });
            this.retentativa = setTimeout(this.tentarSenhaSalva, ESPERA_RECONEXAO_MS);
        }
    }

    handlePasswordConfirm = async (password, lembrar) => {
        const passwordCorrect = await this.checkPassword(password);
        // Se a senha estiver incorreta, mantém o modal aberto
        if (!passwordCorrect) {
            return;
        }
        if (lembrar) {
            salvarSenha(password);
        }
        this.liberarPainel();
    }

    liberarPainel = () => {
        // Fecha o modal e carrega os dados
        this.setState({
            showPasswordModal: false,
            passwordValidated: true
        }, () => {
            this.carregar();
            this.interval = setInterval(() => this.carregar(), RECARGA_MS);
        });
    }

    handlePasswordCancel = () => {
        // Se cancelar, redireciona
        window.location.href = "https://www.lukos.com.br";
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        clearTimeout(this.retentativa);
    }

    // Busca uma consulta por vez (o servidor da API tem limite de conexões);
    // o que falhar mantém o valor anterior na tela.
    carregar = async () => {
        if (this.buscando) {
            return;
        }
        this.buscando = true;
        const buscas = {
            resumo: '/chamados/dashboard',
            noticias: '/lukos/noticias',
            porHora: '/chamados/porhora',
            emAberto: '/chamados/GrafEmAberto',
            finalizadosGraf: '/chamados/GrafFinal',
            tipos: '/chamados/ChamadoPorTipoJson',
            duracao: '/chamados/porTempo',
            clientes: '/chamados/top10hoje',
            chamadosDia: '/chamados/TempoChamado',
            atendentesON: '/chamados/AtendenteON',
        };
        const chaves = Object.keys(buscas);
        const novo = {};
        let falhas = 0;
        for (const chave of chaves) {
            try {
                const dados = (await auth.get(buscas[chave])).data;
                novo[chave] = chave === 'noticias' ? ((dados && dados.linhas) || []) : dados;
            } catch (error) {
                falhas++;
            }
        }
        this.buscando = false;
        if (falhas === chaves.length) {
            // Nada chegou: se já havia dados, eles ficam na tela com o aviso no topo
            this.setState({ falhas, semConexao: !this.state.carregado });
            return;
        }
        this.setState({ ...novo, falhas, semConexao: false, carregado: true, atualizadoEm: new Date() });
    }

    // Junta as respostas da API nos números que a tela mostra.
    indicadores() {
        const s = this.state;
        const resumo = s.resumo || {};
        const horas = montarPorHora(s.porHora);
        const ritmo = ritmoDoDia(horas);
        const fila = montarFila(s.chamadosDia);
        const demorados = montarMaisDemorados(s.chamadosDia);
        const tipos = montarTipos(s.tipos);
        const clientes = montarClientes(s.clientes);
        const abertosPorNome = contagemPorNome(s.emAberto, 'GrafAberto');
        const finalizadosPorNome = contagemPorNome(s.finalizadosGraf, 'GrafFinalizado');
        const atendentes = montarAtendentes(s.atendentesON, abertosPorNome, finalizadosPorNome, resumo.proximoNoChamado);
        // O resumo da API (/chamados/dashboard) exclui o LUK (login 'LUK'); os gráficos por
        // atendente não. Os chamados do LUK entram somados a partir deles.
        const luk = { fechados: finalizadosPorNome[LOGIN_LUK] || 0, abertos: abertosPorNome[LOGIN_LUK] || 0 };
        // Estimativa de capacidade: média de fechados por atendente que fechou chamado hoje.
        const fechadosPorAtendente = Object.keys(finalizadosPorNome)
            .filter((nome) => nome !== LOGIN_LUK && finalizadosPorNome[nome] > 0)
            .map((nome) => finalizadosPorNome[nome]);
        luk.mediaAtendente = fechadosPorAtendente.length
            ? fechadosPorAtendente.reduce((a, b) => a + b, 0) / fechadosPorAtendente.length
            : 0;
        luk.equivaleAtendentes = luk.mediaAtendente > 0 ? luk.fechados / luk.mediaAtendente : 0;
        luk.tempoMedio = tempoMedioFinalizados(s.chamadosDia, LOGIN_LUK);
        const duracao = montarDuracao(s.duracao);
        const alertas = montarAlertas({ resumo, fila, ritmo, clientes, tipos });
        return { resumo, luk, horas, ritmo, fila, demorados, tipos, clientes, atendentes, duracao, alertas };
    }

    textoRitmo(ritmo) {
        if (Math.abs(ritmo.variacao) < 10) return 'dentro do normal';
        return `${formatarPercentual(ritmo.variacao)} ${ritmo.variacao > 0 ? 'acima' : 'abaixo'} do normal`;
    }

    renderStatus() {
        const { falhas, atualizadoEm } = this.state;
        return (
            <div className={`painel-status ${falhas ? 'painel-status--falha' : ''}`}>
                {falhas > 0 ? (
                    <>
                        <Icon>cloud_off</Icon>
                        {falhas} {falhas === 1 ? 'consulta falhou' : 'consultas falharam'} na última atualização · mostrando o último dado
                    </>
                ) : (
                    <>
                        <span className="painel-ponto" aria-hidden="true" />
                        Atualizado às {horaMinuto(atualizadoEm)} · atualiza sozinho a cada minuto
                    </>
                )}
            </div>
        );
    }

    renderAlertas(alertas) {
        return (
            <div className="insights" aria-label="O que pede atenção agora">
                {alertas.slice(0, 6).map((a, i) => (
                    <div key={i} className={`insight insight--${a.nivel}`}>
                        <Icon className="insight-icone">{a.icone}</Icon>
                        <div>
                            <span className="insight-nivel">{NIVEL_ROTULO[a.nivel]}</span>
                            <strong>{a.titulo}</strong>
                            <span className="insight-detalhe">{a.detalhe}</span>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    renderNumeros({ resumo, luk, ritmo }) {
        // Equipe = o que a API conta (sem o LUK); total = equipe + LUK, igual ao CRM.
        const abertosEquipe = num(resumo.chamadosEmAberto);
        const finalizadosEquipe = num(resumo.finalizados);
        const totalEquipe = num(resumo.totalChamados);
        const abertos = abertosEquipe + luk.abertos;
        const finalizados = finalizadosEquipe + luk.fechados;
        const total = totalEquipe + luk.fechados + luk.abertos;
        const online = num(resumo.atendentesON);
        const zap = num(resumo.filaZAP);
        const pct = (parte) => (total > 0 ? `${Math.round((parte / total) * 100)}%` : '0%');
        const nivelFila = online > 0 && abertosEquipe > online ? 'critico' : (abertosEquipe > 0 && abertosEquipe === online ? 'serio' : null);
        const nivelZap = zap >= 200 ? 'critico' : (zap >= 100 ? 'serio' : null);

        const blocos = [
            {
                titulo: 'Chamados hoje', valor: total, cor: 'success', icone: 'support',
                sub: {
                    rotulo: 'IA', valor: luk.fechados + luk.abertos,
                    detalhe: `${luk.fechados} fechados · ${luk.abertos} em atendimento · equipe ${totalEquipe}`,
                },
                rodape: ritmo ? `Normal até agora: ${ritmo.esperado} · ${this.textoRitmo(ritmo)}` : `Média do dia: ${num(resumo.mediaDiaSemana)}`,
                extras: [`Média do dia: ${num(resumo.mediaDiaSemana)} (semana) · ${num(resumo.mediaDiaMes)} (mês)`],
            },
            {
                titulo: 'Fechados pelo LUK (IA)', valor: luk.fechados, cor: 'primary', icone: 'smart_toy', destaque: true,
                rodape: `${pct(luk.fechados)} dos chamados de hoje`,
                extras: [
                    luk.equivaleAtendentes > 0
                        ? `Equivale a ~${luk.equivaleAtendentes.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} atendente(s): a equipe fechou ${luk.mediaAtendente.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} por pessoa hoje`
                        : null,
                    luk.abertos ? `${luk.abertos} em atendimento pelo LUK agora` : 'Nenhum com o LUK agora',
                ].filter(Boolean),
            },
            {
                titulo: 'Em aberto', valor: abertos, cor: 'warning', icone: 'support_agent', nivel: nivelFila,
                rodape: `Equipe ${abertosEquipe} · IA ${luk.abertos}`,
                extras: [`${online > 0 ? (abertosEquipe / online).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) : 0} por atendente online`],
            },
            {
                titulo: 'Finalizados', valor: finalizados, cor: 'success', icone: 'done_all',
                rodape: `${pct(finalizados)} dos chamados de hoje`,
                extras: [`Equipe ${finalizadosEquipe} · IA ${luk.fechados}`],
            },
            {
                titulo: 'Tempo médio', valor: num(resumo.tempoMedio), unidade: 'min', cor: 'info', icone: 'access_time',
                sub: luk.tempoMedio !== null ? {
                    rotulo: 'IA', valor: formatarMinutos(luk.tempoMedio),
                    detalhe: `${formatarMinutos(luk.tempoMedio)} em ${luk.fechados} fechados · equipe ${num(resumo.tempoMedio)} min`,
                } : null,
                rodape: `Equipe · tempo total hoje: ${formatarMinutos(resumo.tempoTotal)}`,
            },
            {
                titulo: 'Atendentes online', valor: online, cor: 'info', icone: 'groups',
                rodape: resumo.proximoNoChamado ? `Próximos: ${resumo.proximoNoChamado}` : 'Sem fila de distribuição',
            },
            {
                titulo: 'WhatsApp', valor: zap, cor: 'success', icone: 'message', nivel: nivelZap,
                rodape: 'Mensagens na fila de envio',
            },
            {
                titulo: 'Retorno pendente', valor: num(resumo.retornoCliente), cor: 'rose', icone: 'manage_history',
                rodape: 'Retornos pendentes ao cliente',
            },
        ];

        return blocos.map((b) => (
            <GridItem key={b.titulo} xs={12} sm={6} md={3}>
                <Card className={`kpi ${b.nivel ? `kpi--${b.nivel}` : ''} ${b.destaque ? 'kpi--destaque' : ''}`}>
                    <CardHeader color={b.cor} stats icon>
                        <CardIcon color={b.cor} className="kpi-icone">
                            <Icon>{b.icone}</Icon>
                        </CardIcon>
                        <h3 className="kpi-valor">
                            {b.valor}
                            {b.unidade && <small className="kpi-unidade">{b.unidade}</small>}
                        </h3>
                        {b.sub && (
                            <p className="kpi-sub" title={b.sub.detalhe}>
                                <Icon className="kpi-sub-icone">smart_toy</Icon>
                                {b.sub.rotulo} – <strong>{b.sub.valor}</strong>
                            </p>
                        )}
                        <p className="kpi-titulo">{b.titulo}</p>
                        {b.nivel && <span className={`kpi-selo kpi-selo--${b.nivel}`}>{NIVEL_ROTULO[b.nivel]}</span>}
                    </CardHeader>
                    <CardFooter stats>
                        <div className="kpi-rodape">
                            {b.sub && <span className="kpi-sub-detalhe">IA: {b.sub.detalhe}</span>}
                            <span>{b.rodape}</span>
                            {(b.extras || []).map((x) => <span key={x} className="kpi-rodape-extra">{x}</span>)}
                        </div>
                    </CardFooter>
                </Card>
            </GridItem>
        ));
    }

    renderFila(fila) {
        const visiveis = fila.slice(0, 10);
        const atrasados = fila.filter((c) => situacaoIdade(c.minutos) === 'critico').length;
        return (
            <Card>
                <CardHeader color="danger">
                    <h4 className="painel-card-titulo">Fila agora</h4>
                    <p className="painel-card-sub">
                        {fila.length} abertos{atrasados ? ` · ${atrasados} há mais de 1h` : ''} · mais antigo primeiro
                    </p>
                </CardHeader>
                <CardBody>
                    {visiveis.length === 0 ? (
                        <p className="painel-vazio">Nenhum chamado aberto agora.</p>
                    ) : (
                        <table className="painel-tabela">
                            <thead>
                                <tr><th>Aberto há</th><th>Chamado</th><th>Responsável</th><th>Cliente</th></tr>
                            </thead>
                            <tbody>
                                {visiveis.map((c) => {
                                    const sit = situacaoIdade(c.minutos);
                                    return (
                                        <tr key={c.chamado} className={`painel-linha--${sit}`}>
                                            <td>
                                                <span className={`idade idade--${sit}`}>
                                                    <span className="idade-marca" aria-hidden="true" />
                                                    {formatarMinutos(c.minutos)}
                                                    {SITUACAO_ROTULO[sit] && <span className="idade-rotulo">{SITUACAO_ROTULO[sit]}</span>}
                                                </span>
                                            </td>
                                            <td className="painel-num">#{c.chamado}</td>
                                            <td>{c.responsavel}</td>
                                            <td className="painel-cortar" title={c.banco}>{c.cliente}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </CardBody>
                {fila.length > visiveis.length && (
                    <CardFooter>+ {fila.length - visiveis.length} chamados abertos não mostrados</CardFooter>
                )}
            </Card>
        );
    }

    renderPorHora(horas, ritmo) {
        const atual = horas.length ? horas[horas.length - 1] : null;
        const dados = {
            labels: horas.map((h) => `${String(h.hora).padStart(2, '0')}h`),
            datasets: [
                {
                    type: 'line',
                    label: 'Normal para a hora (média)',
                    data: horas.map((h) => h.media),
                    borderColor: COR.media,
                    backgroundColor: COR.media,
                    borderWidth: 2,
                    pointRadius: 0,
                    pointHoverRadius: 5,
                    fill: false,
                    lineTension: 0.3,
                },
                {
                    type: 'bar',
                    label: 'Chamados abertos',
                    data: horas.map((h) => h.abertos),
                    backgroundColor: horas.map((h) => (h.hoje ? COR.serie : COR.serieOntem)),
                    hoverBackgroundColor: COR.serie,
                    borderWidth: 0,
                    barPercentage: 0.8,
                    categoryPercentage: 0.9,
                },
            ],
        };
        const opcoes = {
            maintainAspectRatio: false,
            legend: { display: true, position: 'top', align: 'end', labels: { fontColor: '#3c4858', boxWidth: 12 } },
            tooltips: { mode: 'index', intersect: false },
            scales: {
                xAxes: [{ gridLines: { display: false }, ticks: { fontColor: COR.eixo, maxRotation: 0, autoSkipPadding: 8 } }],
                yAxes: [{ gridLines: { color: COR.grade, zeroLineColor: COR.grade, drawBorder: false }, ticks: { fontColor: COR.eixo, beginAtZero: true, precision: 0, maxTicksLimit: 5 } }],
            },
        };
        return (
            <Card>
                <CardHeader color="primary">
                    <h4 className="painel-card-titulo">Chamados por hora</h4>
                    <p className="painel-card-sub">
                        Últimas 24h · barras claras são de ontem{atual ? ` · hora atual: ${atual.abertos} (normal ${atual.media})` : ''}
                    </p>
                </CardHeader>
                <CardBody>
                    <div className="painel-grafico">
                        {horas.length ? <Bar data={dados} options={opcoes} /> : <p className="painel-vazio">Sem dados por hora.</p>}
                    </div>
                </CardBody>
                {ritmo && (
                    <CardFooter>
                        <span>
                            Hoje até agora: <strong>{ritmo.realizado}</strong> chamados; o normal para este horário seria <strong>{ritmo.esperado}</strong> ({this.textoRitmo(ritmo)}).
                        </span>
                    </CardFooter>
                )}
            </Card>
        );
    }

    renderAtendentes(atendentes) {
        const ordenados = [...atendentes].sort((a, b) => b.qtde - a.qtde || a.login.localeCompare(b.login));
        const maior = Math.max(1, ...ordenados.map((a) => a.qtde));
        return (
            <Card>
                <CardHeader color="info">
                    <h4 className="painel-card-titulo">Atendentes online</h4>
                    <p className="painel-card-sub">{atendentes.length} online · o selo indica a ordem para o próximo chamado</p>
                </CardHeader>
                <CardBody>
                    {ordenados.length === 0 ? (
                        <p className="painel-vazio">Nenhum atendente online.</p>
                    ) : (
                        <table className="painel-tabela">
                            <thead>
                                <tr>
                                    <th>Atendente</th>
                                    <th className="painel-num">Agora</th>
                                    <th>Chamados hoje</th>
                                    <th className="painel-num">Finaliz.</th>
                                    <th className="painel-num">Em chamado</th>
                                    <th className="painel-num">Pontos</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ordenados.map((a) => (
                                    <tr key={a.login}>
                                        <td>
                                            {a.proximo && <span className="proximo" title="Ordem para receber o próximo chamado">{a.proximo}º</span>}
                                            {a.login}
                                        </td>
                                        <td className="painel-num">{a.abertos || '–'}</td>
                                        <td>{this.renderBarra(a.qtde, maior)}</td>
                                        <td className="painel-num">{a.finalizados}</td>
                                        <td className="painel-num">{formatarMinutos(a.tempoChamado)}</td>
                                        <td className="painel-num">{a.pontuacao.toLocaleString('pt-BR')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </CardBody>
            </Card>
        );
    }

    renderBarra(qtde, maior) {
        return (
            <span className="barra-linha">
                <span className="barra-trilho">
                    <span className="barra" style={{ width: `${(qtde / maior) * 100}%` }} />
                </span>
                <span className="barra-valor painel-num">{qtde}</span>
            </span>
        );
    }

    renderBarras({ cor, titulo, sub, itens, rotulo, extra, vazio }) {
        const maior = Math.max(1, ...itens.map((i) => i.qtde));
        return (
            <Card>
                <CardHeader color={cor}>
                    <h4 className="painel-card-titulo">{titulo}</h4>
                    <p className="painel-card-sub">{sub}</p>
                </CardHeader>
                <CardBody>
                    {itens.length === 0 ? <p className="painel-vazio">{vazio}</p> : (
                        <ul className={`barras ${extra ? '' : 'barras--sem-extra'}`}>
                            {itens.map((i) => (
                                <li key={rotulo(i)}>
                                    <span className="barras-rotulo" title={rotulo(i)}>{rotulo(i)}</span>
                                    {this.renderBarra(i.qtde, maior)}
                                    {extra && <span className="barras-extra painel-num">{extra(i)}</span>}
                                </li>
                            ))}
                        </ul>
                    )}
                </CardBody>
            </Card>
        );
    }

    renderDuracao(duracao) {
        const total = duracao.reduce((s, d) => s + d.qtde, 0);
        return (
            <Card>
                <CardHeader color="warning">
                    <h4 className="painel-card-titulo">Duração dos chamados</h4>
                    <p className="painel-card-sub">Chamados de hoje por faixa de tempo</p>
                </CardHeader>
                <CardBody>
                    {total === 0 ? <p className="painel-vazio">Sem chamados hoje.</p> : (
                        <>
                            <div className="faixas" role="img"
                                aria-label={duracao.map((d) => `${d.faixa}: ${d.qtde}`).join(', ')}>
                                {duracao.map((d, i) => d.qtde > 0 && (
                                    <span key={d.faixa} className={`faixa faixa--${i}`} style={{ flexGrow: d.qtde }} />
                                ))}
                            </div>
                            <ul className="faixas-legenda">
                                {duracao.map((d, i) => (
                                    <li key={d.faixa}>
                                        <span className={`faixa-marca faixa--${i}`} aria-hidden="true" />
                                        <span className="faixas-nome">{d.faixa}</span>
                                        <strong className="painel-num">{d.qtde}</strong>
                                        <span className="faixas-pct painel-num">{Math.round((d.qtde / total) * 100)}%</span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </CardBody>
            </Card>
        );
    }

    renderDemorados(demorados) {
        return (
            <Card>
                <CardHeader color="rose">
                    <h4 className="painel-card-titulo">Mais demorados hoje</h4>
                    <p className="painel-card-sub">Chamados já finalizados, pela duração do atendimento</p>
                </CardHeader>
                <CardBody>
                    {demorados.length === 0 ? <p className="painel-vazio">Nenhum chamado finalizado hoje.</p> : (
                        <table className="painel-tabela">
                            <thead>
                                <tr><th>Duração</th><th>Chamado</th><th>Responsável</th><th>Cliente</th></tr>
                            </thead>
                            <tbody>
                                {demorados.map((c) => (
                                    <tr key={c.chamado}>
                                        <td className="painel-num"><strong>{formatarMinutos(c.minutos)}</strong></td>
                                        <td className="painel-num">#{c.chamado}</td>
                                        <td>{c.responsavel}</td>
                                        <td className="painel-cortar" title={c.banco}>{c.cliente}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </CardBody>
            </Card>
        );
    }

    renderNoticias(noticias) {
        if (!noticias || !noticias.length) return null;
        return (
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="warning">
                        <h4 className="painel-card-titulo">Notícias</h4>
                    </CardHeader>
                    <CardBody>
                        <div className="noticias">
                            {noticias.map((n, i) => (
                                <div key={i} className="noticia">
                                    <Icon>campaign</Icon>
                                    <div>
                                        <strong>{n.titulo}</strong>
                                        <span>{n.noticia}</span>
                                        {n.rodape && <small>{n.rodape}</small>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>
            </GridItem>
        );
    }

    render() {
        const { passwordValidated, carregado, semConexao, noticias } = this.state;
        const modal = (
            <PasswordModal
                open={this.state.showPasswordModal}
                onConfirm={this.handlePasswordConfirm}
                onCancel={this.handlePasswordCancel}
                message="Por favor, insira a senha:"
            />
        );
        if (!passwordValidated || !carregado) {
            return (
                <div>
                    {modal}
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        {semConexao ? (
                            <>
                                <h4>Sem conexão com o servidor da API.</h4>
                                <p>O painel tenta de novo sozinho a cada {(passwordValidated ? RECARGA_MS : ESPERA_RECONEXAO_MS) / 1000} segundos.</p>
                            </>
                        ) : (
                            <h4>Carregando...</h4>
                        )}
                    </div>
                </div>
            );
        }

        const ind = this.indicadores();
        return (
            <div className="painel">
                {modal}
                {this.renderStatus()}
                {this.renderAlertas(ind.alertas)}
                <GridContainer>
                    {this.renderNoticias(noticias)}
                    {this.renderNumeros(ind)}
                    <GridItem xs={12} md={12} lg={5}>{this.renderFila(ind.fila)}</GridItem>
                    <GridItem xs={12} md={12} lg={7}>{this.renderPorHora(ind.horas, ind.ritmo)}</GridItem>
                    <GridItem xs={12} md={12} lg={5}>{this.renderAtendentes(ind.atendentes)}</GridItem>
                    <GridItem xs={12} md={6} lg={4}>
                        {this.renderBarras({
                            cor: 'info', titulo: 'Por tipo de chamado', sub: 'Quantidade hoje · tempo médio',
                            itens: ind.tipos, rotulo: (t) => t.tipo, extra: (t) => formatarMinutos(t.tempoMedio),
                            vazio: 'Sem chamados classificados hoje.',
                        })}
                    </GridItem>
                    <GridItem xs={12} md={6} lg={3}>
                        {this.renderBarras({
                            cor: 'success', titulo: 'Clientes com mais chamados', sub: 'Hoje',
                            itens: ind.clientes.slice(0, 10), rotulo: (c) => c.banco.replace(/^Lukos_/i, ''),
                            vazio: 'Nenhum chamado hoje.',
                        })}
                    </GridItem>
                    <GridItem xs={12} md={6}>{this.renderDuracao(ind.duracao)}</GridItem>
                    <GridItem xs={12} md={6}>{this.renderDemorados(ind.demorados)}</GridItem>
                </GridContainer>
            </div>
        );
    }
}


export default CompDashBoard;
